import { createElement } from 'react';
import './index.scss';
import { Collapse as NextCollapse } from '@alifd/next';
const Collapse = ({ dataList, itemList, children, ...otherProps }) => {
    const _otherProps = otherProps || {};
    const Panel = NextCollapse.Panel;
    const renderContent = (content) => {
        if (!content)
            return null;
        const contentArray = content.split(',');
        return (createElement("div", { className: "collapse-content-list" }, contentArray.map((item, index) => (createElement("div", { key: index, className: "collapse-content-item" }, item.trim())))));
    };
    const renderItems = () => {
        if (dataList?.length > 0) {
            return dataList.map((item, index) => (createElement(Panel, { key: index, title: item.title }, item.content && renderContent(item.content))));
        }
        if (itemList?.length > 0) {
            return itemList.map((item, index) => (createElement(Panel, { key: index, title: item.title }, item.content)));
        }
    };
    return createElement(NextCollapse, { ..._otherProps }, renderItems());
};
Collapse.displayName = 'Collapse';
export default Collapse;
